import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type TodoListViewerFragment = { __typename?: 'Viewer', todoList: { __typename?: 'TodoList', showSeminar: boolean, showAutoKartePlannerCommentSetting: boolean, showWriteProfile: boolean } };

export const TodoListViewerFragmentDoc = gql`
    fragment TodoListViewer on Viewer {
  todoList {
    showSeminar
    showAutoKartePlannerCommentSetting
    showWriteProfile
  }
}
    `;